module.exports = "dist/images/components-design-separator-control-wave-2.8ad6a1d.png";